import './ViewDialog.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import useAxiosHook from '../../../../../hooks/useAxiosHook';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import { EntityIdRouteParams } from '../../../../../types/routing';
import DialogSpinner from '../../../../Dialogs/DialogSpinner/DialogSpinner';

type Props = {
  isShown: boolean;
  onHide: () => void;
  isEditBtnShown: boolean;
  setIsEditDialog: (isEditDialog: any) => void;
};

function ViewDialog({
  isShown,
  onHide,
  isEditBtnShown,
  setIsEditDialog,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const { id } = useParams<EntityIdRouteParams>();
  const isOnMobile = useMediaQuery('(max-width: 768px)');

  const { data, isLoading } = useAxiosHook<any>(`/price-lists/${id}`, {
    skipWhen: !isShown && !id,
  });

  const dialogFooter = !isLoading && (
    <>
      {isEditBtnShown && (
        <Button
          label={t('Edit')}
          className="p-button-text"
          onClick={() => setIsEditDialog(data!)}
        />
      )}
      <Button label={t('Close')} onClick={() => onHide()} />
    </>
  );

  return (
    <Dialog
      header={isLoading ? t('Loading...') : t('Preview price list')}
      footer={dialogFooter}
      visible={isShown}
      resizable={false}
      onHide={onHide}
      maximizable
      maximized={isOnMobile}
      style={{ width: 580, maxWidth: '100%' }}
      className="price-lists-view-dialog"
    >
      {isLoading ? (
        <DialogSpinner />
      ) : (
        <>
          <span className="section-title">{t('General information')}</span>
          <table cellPadding="0" cellSpacing="0">
            <tbody>
              <tr>
                <td>{t('Base price list')}</td>
                <td className="route-name">{data?.parent_name}</td>
              </tr>
              <tr>
                <td>{t('Name')}</td>
                <td className="route-name">{data?.name}</td>
              </tr>
              <tr>
                <td>{t('Description')}</td>
                <td className="route-name">{data?.description}</td>
              </tr>
              <tr>
                <td>{t('Created by')}</td>
                <td className="route-name">{data?.created_by_full_name}</td>
              </tr>
              <tr>
                <td>{t('Created at')}</td>
                <td className="route-name">{data?.created_at}</td>
              </tr>
              <tr>
                <td>{t('Modified at')}</td>
                <td className="route-name">{data?.modified_at}</td>
              </tr>
              <tr>
                <td>{t('Modified by')}</td>
                <td className="route-name">{data?.modified_at}</td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </Dialog>
  );
}

export default ViewDialog;
